import React from "react";
import { ButtonBase } from "@mui/material";
import { EsgLeftArrow } from "assets";
import { COLORS } from "components/consts";
import { Label14Bold } from "components/typography";

interface ReturnButtonProps {
    label: string;
    onClick: () => void;
}
export const ReturnButton = ({ label, onClick }: ReturnButtonProps) => <ButtonBase sx={{
    display: "flex",
    width: "fit-content",
    justifyContent: "flex-start",
    alignItems: "center",
    color: COLORS.Mainblue,
    gap: 1,
    "&:active": {
        backgroundColor: "rgba(0, 0, 0, 0.12)",
    },
}}
    onClick={onClick}
>
    <EsgLeftArrow />
    <Label14Bold>{label}</Label14Bold>
</ButtonBase>